export default __webpack_public_path__ + "static/media/githubIcon.539ab584.png";